import { render, staticRenderFns } from "./sel-box.vue?vue&type=template&id=61419f68&scoped=true"
import script from "./sel-box.vue?vue&type=script&lang=js"
export * from "./sel-box.vue?vue&type=script&lang=js"
import style0 from "./sel-box.vue?vue&type=style&index=0&id=61419f68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61419f68",
  null
  
)

export default component.exports